import { render, staticRenderFns } from "./StageSymptoms.vue?vue&type=template&id=49d4aff4"
import script from "./StageSymptoms.vue?vue&type=script&lang=js"
export * from "./StageSymptoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports